import T from 'prop-types';

export default {
  role: T.string.isRequired,
  resetForm: T.func.isRequired,
  setFieldValue: T.func.isRequired,
  handleSubmit: T.func.isRequired,
  userColor: T.string.isRequired,
  values: T.object.isRequired,
  errors: T.object.isRequired,
  isRecoveryUpdating: T.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/shapes/goals.js